export default (
  <svg xmlns="http://www.w3.org/2000/svg" width="45" height="32" fill="none">
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M42.387 2.715a5.429 5.429 0 0 1 1.402 2.42c1.426 5.742 1.097 14.81.027 20.772a5.429 5.429 0 0 1-3.821 3.822c-3.351.914-16.839.914-16.839.914s-13.487 0-16.838-.914a5.429 5.429 0 0 1-3.822-3.822c-1.435-5.716-1.042-14.79-.028-20.744A5.428 5.428 0 0 1 6.29 1.342C9.64.428 23.128.4 23.128.4s13.488 0 16.839.914c.915.248 1.75.73 2.42 1.401ZM30.024 15.521l-11.188 6.481V9.041l11.188 6.48Z"
    />
  </svg>
);
